var _style, _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-chat_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-chat_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-chat_svg__st0",
    d: "M4.8 22.4c-.2 0-.3 0-.5-.1-.3-.2-.5-.6-.5-1l.3-3.9c-2-1.7-3.2-4.1-3.2-6.5 0-5.1 4.9-9.3 11-9.3s11 4.2 11 9.3c0 5.1-4.9 9.3-11 9.3-1.2 0-2.3-.1-3.3-.4l-3.2 2.4c-.1.1-.3.2-.6.2zM12 3.6c-5 0-9 3.3-9 7.3 0 2 1 3.9 2.8 5.3.3.2.4.5.4.9L6 19.3l1.8-1.4c.3-.2.6-.3.9-.2 1 .3 2.1.5 3.2.5 5 0 9-3.3 9-7.3.1-4-3.9-7.3-8.9-7.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    className: "icon-chat_svg__st0",
    cx: 8.1,
    cy: 10.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon-chat_svg__st0",
    cx: 12,
    cy: 10.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon-chat_svg__st0",
    cx: 15.9,
    cy: 10.9,
    r: 1.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#050505",
    strokeWidth: 0.738,
    strokeMiterlimit: 10,
    d: "M4.1 18.6h0"
  })));
}

export default SvgIconChat;